'use strict';

/* jshint maxcomplexity:9 */

var _ = require('lodash');
var React = require('react');
var classNames = require('classnames');

var Header = require('./common-parts/header.jsx');
var Video = require('./common-parts/video.jsx');
var Share = require('./common-parts/share.jsx');
var Aggregator = require('./common-parts/aggregator.jsx');
var PictureChooser = require('./common-parts/picturechooser');
var at = require('../utils/environment');

var cssBackgroundUrl = _.template('url("<%= url %>")');


var classDefinition = {

    getInitialState: function() {
        this.props.content.url = (this.props.content.url || null);
        return null;
    },

    getContentType: function(){
        return this.props.type;
    },

    renderVideo: function() {
        var videoInfo = this.props.content.video;

        if (videoInfo && videoInfo.id)
            return <Video content={this.props.content} aggregated={false} />;
        else return null;
    },

    getAltImage: function(content) {
        var url = content.image && content.image.url;
        var rightsHolder = content.image && content.image.rightsHolder;
        return (url && rightsHolder? 'Foto: (' + rightsHolder + ')': '');
    },

    renderImage: function() {
        var content = this.props.content;
        var imageUrl;
        var cover = {};
        var img;
        var alt = null;

        if (content.image === undefined) return null;

        if (at.client) {
            imageUrl = PictureChooser.choose(content);
            alt = this.getAltImage(content);
            cover = { backgroundImage: cssBackgroundUrl({ url: imageUrl }) };
            img = <img src={imageUrl} alt={alt} />;
        }

        return (
            <figure className='gui-image-full' style={cover} alt={alt} title={alt}>
                {img}
            </figure>
        );
    },

    hasMedia: function() {
        var content = this.props.content;
        var videoInfo = content.video;

        if (videoInfo && videoInfo.id) return true;
        if (content.image) return true;
        return false;
    },

    renderMedia: function() {
        var video;
        var image;
        var media;
        var figure = null;
        var content = this.props.content;
        var context = (at.client? window : {});

        if (this.hasMedia() === false) return null;

        if (_.get(context, 'SETTINGS.BASTIAN.IS_PHOTO_PRIORIZED', false)) {
            image = this.renderImage();
            video = (image? null : this.renderVideo());
            media = (image || video);
        } else {
            video = this.renderVideo();
            image = (video? null : this.renderImage());
            media = (video || image);
        }

        if (media) figure = (
            <a href={content.url}
                className='feed-post-figure-link gui-image-hover gui-color-primary-link'>
                    {media}
            </a>
        );

        return figure;
    },

    renderHeader: function() {
        return <Header
                    isRecommended={this.props.isRecommended}
                    content={this.props.content}
                    age={this.props.age} />;
    },

    renderTitle: function() {
        return (
            <p className='feed-post-body-title gui-text-title gui-color-primary'>
                {this.props.content.title}
            </p>
        );
    },

    renderAggregateds: function() {
        var aggregates = this.props.aggregatedPosts;
        if (aggregates && aggregates.length)
            return <Aggregator items={aggregates} />;
        else return null;
    },

    render: function() {
        var content = this.props.content;
        var summary;
        var aggregateds = this.renderAggregateds();

        var postClass = classNames('feed-post', {
            'no-image': (this.hasMedia() === false)
        });

        // TODO: Needs testing.
        if (aggregateds) summary = null;
        else summary = <p className='feed-post-body-resumo'>{content.summary}</p>;

        return (
            <div
              className={postClass}
              data-post-type={this.getContentType()}
              data-post-id={this.props.id}>
                <div className='feed-post-body'>
                    {this.renderMedia()}
                    <span className='feed-text-wrapper'>
                        {this.renderHeader()}
                        <a href={content.url} className='feed-post-link gui-image-hover gui-color-primary-link'>
                            {this.renderTitle()}
                            {summary}
                        </a>
                        {aggregateds}
                        <Share
                            url={content.url}
                            title={content.title}
                            imageUrl={PictureChooser.choose(content)}
                        />
                    </span>
                </div>
            </div>
        );
    }
};

module.exports = {
    SimplePostArticle: React.createClass(classDefinition),
    classDefinition: classDefinition
};
